import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import UpdatePackageDetail from '../../components/admincomponents/UpdatePackegeDetail';

function UpdatePackege({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <UpdatePackageDetail />            
    </>
  );
}

export default UpdatePackege;
